export default "__VITE_ASSET__BTl72PdG__"